import { createClient } from '@supabase/supabase-js';

// Define the database types based on our schema
export type Database = {
  public: {
    Tables: {
      organizations: {
        Row: {
          id: string;
          name: string;
          type: string;
          wallet_balance: number;
          low_balance_threshold: number;
          filter_expiry_products: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          type: string;
          wallet_balance?: number;
          low_balance_threshold?: number;
          filter_expiry_products?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          type?: string;
          wallet_balance?: number;
          low_balance_threshold?: number;
          filter_expiry_products?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
      profiles: {
        Row: {
          id: string;
          email: string;
          role: 'superadmin' | 'admin' | 'user';
          organization_id: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email: string;
          role: 'superadmin' | 'admin' | 'user';
          organization_id: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          role?: 'superadmin' | 'admin' | 'user';
          organization_id?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      sim_cards: {
        Row: {
          id: string;
          organization_id: string;
          msisdn: string | null;
          iccid: string;
          status: string;
          auto_topup_enabled: boolean;
          auto_topup_config: Record<string, any>;
          balance: number;
          balance_last_checked: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          organization_id: string;
          msisdn?: string | null;
          iccid: string;
          status: string;
          auto_topup_enabled?: boolean;
          auto_topup_config?: Record<string, any>;
          balance?: number;
          balance_last_checked?: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          organization_id?: string;
          msisdn?: string | null;
          iccid?: string;
          status?: string;
          auto_topup_enabled?: boolean;
          auto_topup_config?: Record<string, any>;
          balance?: number;
          balance_last_checked?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};

export type Profile = {
  id: string;
  email: string;
  role: 'superadmin' | 'admin' | 'user';
  organization_id: string;
  created_at: string;
  updated_at: string;
};

// Create the Supabase client
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('Supabase URL:', supabaseUrl); // Debug log

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Ensure the URL is properly formatted with https://
const formattedUrl = supabaseUrl.trim().startsWith('https://') 
  ? supabaseUrl.trim() 
  : `https://${supabaseUrl.trim()}`;

export const supabase = createClient<Database>(formattedUrl, supabaseAnonKey);
